import {
    ApolloClient,
    InMemoryCache,
    createHttpLink,
    createQueryPreloader,
    from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import config from 'config'
import store from 'shared/state'
import { addToast } from 'shared/state/toastSlice'
import { deleteToken, getToken } from 'shared/utils/auth'

// Apollo Authentication: https://www.apollographql.com/docs/react/networking/authentication/#header

const httpLink = createHttpLink({
    uri: config.graphql.uri,
})

const authLink = setContext((_, { headers }) => {
    const token = getToken()

    return {
        headers: {
            ...headers,
            authorization: token
                ? `Bearer ${token}`
                : headers?.authorization
                  ? headers?.authorization
                  : '',
        },
    }
})

export const invalidTokenErrors = [
    'Authorization token not found',
    'Invalid Token',
    'ApolloError: Invalid Token',
    'Unauthorized for this role',
]

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) => {
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
            if (invalidTokenErrors.includes(message)) {
                const returnPath =
                    window.location.pathname + window.location.search
                const loginUrl = `/login?to=${encodeURIComponent(returnPath)}`
                store.dispatch(
                    addToast({
                        title: 'Error',
                        message,
                        severity: 'error',
                        timestamp: undefined,
                        inline: false,
                        timeout: 5000,
                        navigate: loginUrl,
                    })
                )
                deleteToken()
            }
        })
    if (networkError) console.error(`[Network error]: ${networkError}`)
})

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([errorLink, authLink, httpLink]),
})

export const resetGQLCache = () => {
    client.clearStore()
}

export const preloadQuery = createQueryPreloader(client)

export default client
